export class ApiError extends Error {
  constructor(
    message: string,
    readonly code?: string,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  if (!(init?.body instanceof FormData) && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  const response = await fetch(path, {
    ...init,
    headers,
  });
  let payload: { ok: boolean; data?: T; message?: string; code?: string };
  try {
    payload = await response.json();
  } catch {
    // Infrastructure failures (including Cloudflare 1102) can return HTML.
    throw new ApiError(
      "서버 응답을 불러오지 못했습니다. 잠시 후 새로고침해 주세요.",
      response.status >= 500 ? "SERVICE_UNAVAILABLE" : "INVALID_RESPONSE",
    );
  }
  if (!response.ok || !payload.ok) throw new ApiError(payload.message || "잠시 후 다시 시도해 주세요.", payload.code);
  return payload.data as T;
}

export function json(method: string, body?: unknown): RequestInit {
  return { method, body: body === undefined ? undefined : JSON.stringify(body) };
}
